import React, { useState, useEffect } from 'react'
import './AddBoxLabelModalContainer.scoped.sass'

import { ReactComponent as CloseIcon } from '@/assets/icons/close-icon.svg'
import { Button } from '@/components/Button/Button'
import { InputMask } from '@/components/InputMask/InputMask'
import labelsService from '@/app-domains/labels/labels.service'
import ToastService from '@/components/Toast/Toast.service'

export function AddLabelModalContainer (props) {
  const [labelName, setLabelName] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const {
    closeAddLabelModal,
    label
  } = props

  const labelsFromStore = Object.values(labelsService.getLabelsFromStore())

  useEffect(() => {
    if (label) setLabelName(label.name)
  }, [])

  const addLabel = () => {
    if (!labelName) {
      setErrorMessage('Field cannot be empty')
      return
    } else {
      setErrorMessage('')
    }
    if (label) {
      return labelsService.updateLabelName(label, labelName).then(() => closeAddLabelModal())
        .catch((err) => {
          throw new Error(err)
        })
    }
    if (labelsFromStore.filter((filteredLabel) => filteredLabel.name === labelName).length !== 0) {
      return (
        ToastService.show({
          type: 'error',
          title: 'There was an error',
          message: 'A label with that name already exists.'
        })
      )
    } else {
      labelsService.createBoxLabel(labelName)
        .then(() => closeAddLabelModal())
        .catch((err) => {
          throw new Error(err)
        })
    }
  }

  const handleLabelNameChange = (value) => {
    if (value.length > 40) {
      return setErrorMessage('Label name length should be lower or equal to 40 characters')
    }
    if (value.length === 0) {
      setLabelName(value)
      return setErrorMessage('Label name cannot be empty')
    }
    setErrorMessage('')
    return setLabelName(value)
  }

  return <div className='add-label-modal'>
    <div className="add-label-top">
      <div className="title">
        {(label ? 'Edit' : 'Create a')} label
      </div>
      <div className="close-button" onClick={closeAddLabelModal}>
        <CloseIcon />
      </div>
    </div>
    <div className="add-label-content">
      <div className='description'>
        Labels help you categorize your email content and boxes.
      </div>
      <div className="input-label">
        <div className="input-label-title">
          Label name
        </div>
        <div className="input">
          <InputMask
            errorMessage={errorMessage}
            value={labelName}
            onInput={handleLabelNameChange}
            placeholder={'Name your label'} />
        </div>
      </div>
    </div>
    <div className="add-label-bottom">
      <div className="cancel">
        <Button type={'secondary'} content={'Cancel'} click={closeAddLabelModal} />
      </div>
      <div>
        <Button disabled={labelName.length === 0 || errorMessage} content={(label ? 'Edit Label' : 'Create Label')} click={addLabel} />
      </div>
    </div>
  </div>
}
